<tui-root [attr.tuiTheme]="darkMode() ? 'dark' : null">
  <router-outlet />

  <div class="consent-modal__backdrop" *ngIf="showConsentModal">
    <div
      class="consent-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="consent-title"
    >
      <h2 id="consent-title">{{ t('consent.title') }}</h2>
      <p>{{ t('consent.description') }}</p>

      <label class="consent-modal__checkbox">
        <input
          type="checkbox"
          [checked]="isConsentChecked"
          (change)="onConsentCheckboxChange($event)"
        />
        <span>
          {{ t('consent.acceptPrefix') }}
          <a [href]="privacyPolicyUrl" target="_blank" rel="noopener">{{
            t('consent.privacyPolicy')
          }}</a>
          {{ t('consent.and') }}
          <a [href]="termsOfServiceUrl" target="_blank" rel="noopener">{{
            t('consent.termsOfService')
          }}</a>
          {{ t('consent.acceptSuffix') }}
        </span>
      </label>

      <button type="button" [disabled]="!isConsentChecked" (click)="acceptConsent()">
        {{ t('consent.continue') }}
      </button>
    </div>
  </div>
</tui-root>